<template>
  <div id="content">
    <business-models-modal ref="businessmodelsmodalref" />
    <form>
      <div class="inner">
        <h1 v-translate>Kanály</h1>
      </div>
      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <div class="field_right">
            <select-box
                id="channeltype"
                :options="channelTypeOptions"
                v-model="formFields.channel_type"
                ref="channeltyperef"
            >
              <translate class="translate">Typ kanálu</translate>
            </select-box>
          </div>
          <div class="field_left field_full">
            <div class="field checkboxes">
              <filter-checkbox
                  v-for="type in formats"
                  :key="type.value"
                  :id="channelFormatId(type.value)"
                  :name="type.text"
                  :val="type.value"
                  v-model="formFields.format">{{ type.text }}
              </filter-checkbox>
              <filter-checkbox
                  key="active-in-platform"
                  id="active-in-platform"
                  name="active-in-platform"
                  :val="1"
                  v-model="formFields.active_in_platform"
              >
                <translate class="translate">Aktivní v platformě</translate>
              </filter-checkbox>
              <filter-checkbox
                  key="hide-deleted"
                  id="hide-deleted"
                  name="hide-deleted"
                  :val="1"
                  v-model="formFields.hide_deleted"
              >
                <translate class="translate">Nezobrazovat smazané</translate>
              </filter-checkbox>
            </div>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <form>
          <div class="scroll-wrapper">
            <div class="table_overflow" id="contentBox" data-table-id="channels-list">
              <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr v-if="entities.length > 0">
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                  <sorting-table-title
                      v-for="title in sortingTableTitles"
                      :key="title.key"
                      :column="title.column"
                      :sort="getActiveSort(title.column)"
                      @changeSorting="changeSorting"
                  >{{ title.name }}
                  </sorting-table-title>
                  <th></th>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <channel-row
                    v-for="entity in entities"
                    :isEditable="$_updateActionAllowed"
                    :channel="entity"
                    :channel-date-updated="entity.date_updated"
                    :key="entity.id"
                    :selectedChannels="selectedEntities"
                    @select="select"
                    @lock-update="updateChannel"
                    @show-business-models="$refs.businessmodelsmodalref.showBusinessModels(arguments[0])"
                ></channel-row>
<tr v-if="entities.length === 0">
     <td colspan="8">{{ $gettext('Nebyly nalezeny žádné kanály.') }}</td>
</tr>
              </table>
            </div>
          </div>

          <list-action-line
              :entities="entities"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              table-id="channels-list"
              @select-all="toggleSelectAll"
              @run-multiple-action="executeMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import ChannelRow from "@/components/views/channels/ChannelRow"
import listActions from "@/components/mixins/list-actions"
import BusinessModelsModal from "../../common/BusinessModelsModal.vue";

export default {
  name: "ChannelList",
  components: { BusinessModelsModal, ChannelRow},
  mixins: [listActions],
  data: function () {
    return {
      moduleName: 'channels',
      formFields: {
        sort: {
          column: 'sWeight',
          direction: 'desc'
        },
        limit: 20,
        format: [],
        active_in_platform: true,
        hide_deleted: true,
        channel_type: 'all',
      },
      formats: [
        {value: '0', text: 'SD'},
        {value: '1', text: 'HD'},
      ],
    }
  },
  computed: {
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
      ];
    },
    sortingTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Logo')},
        {key: 3, name: this.$gettext('ID'), column: 'sId'},
        {key: 4, name: this.$gettext('ID EPG'), column: 'sEpgId'},
        {key: 5, name: this.$gettext('Typ kanálu'), column: 'sType'},
        {key: 6, name: this.$gettext('V balíčcích a službách'), column: 'sInPackagesAndServices'},
        {key: 7, name: this.$gettext('Na zdrojích obsahů'), column: 'sOnContentSources'},
        {key: 8, name: this.$gettext('Váha'), column: 'sWeight'},
        {key: 9, name: this.$gettext('Zámek'), column: 'sParentalLock'},
        {key: 10, name: this.$gettext('Typ EPG'), column: 'sEpgType'},
      ]
    },
    channelTypeOptions() {
      return [
        {id: 'all', text: this.$gettext('Všechny')},
        {id: '1', text: this.$gettext('TV')},
        {id: '2', text: this.$gettext('Rádio')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
      headers['hd'] = {name: 'HD', callback: (entity => {return Boolean(entity.hd) ? this.$gettext('Ano') : this.$gettext('Ne')})};
      headers.Logo.callback = entity => {return entity.logo_url};
      headers.epg_id.callback = entity => {return entity.id_epg};
      headers.type.callback = entity => {return entity.id_type == 1 ? this.$gettext('TV') : this.$gettext('Rádio')};
      headers.in_packages_and_services.callback = entity => {return entity.channel_packages_count + ' / ' + entity.services_count};
      headers.on_content_sources.callback = entity => {return Object.keys(entity.channel_content_info).length};
      headers.parental_lock.callback = entity => {return Boolean(entity.parental_lock) ? this.$gettext('Aktivní') : this.$gettext('Neaktivní')};

      return headers;
    },
  },
  created(ChannelService) {
    this.entityService = ChannelService
    this.createdInit()
  },
  methods: {
    channelFormatId(id) {
      return 'channel-format-' + id
    },
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('format')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('channel_type') && this.formFields.channel_type !== 'all') {
        anyChanges = true
      }
      return anyChanges
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
      this.setUserSetting('format', this.formFields.format)
      this.setUserSetting('channel_type', this.formFields.channel_type)
    },
    executeMultipleAction(action) {
      this.runMultipleAction(action);
    },
    updateChannel(id, params) {
      this.entityService.updateEntity(id, params)
          .then(() => {
            this.setSuccessMessage()
            this.getEntities()
          })
          .catch(error => {
            this.setErrorMessage(error['error_message'])
          })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/channels/ChannelList.vue